import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const btnColor = greys.standard;
export const btnColorSaving = greys.blueGrey;

export const syncing: CSSProperties = {
  padding: `5px 6px 10px`,
  fontSize: 14,
  lineHeight: 1.4,
  color: greys.slate,
};
